import config from "../environments/config";

/**
 * Where the "Assistant" link goes, or null when it must not be shown: the flag is off (the
 * default), no address is configured, or the user isn't a super user / product-team member
 * (the Runbook Builder tools behind it refuse everyone else), or an allowlist is set (a trial
 * with a few people) and the user isn't on it. Hiding the link is not access control: the chat
 * itself is open to any eligible user who has its address. The chat signs the user in
 * through this portal's existing redirect, so a signed-in user lands in it without a login.
 */
export function assistantLinkFor(user, cfg = config) {
  if (!cfg.assistantEnabled || !cfg.assistantUrl) return null;
  if (!(user?.isSuperUser || user?.isProductTeam)) return null;
  const allowed = cfg.assistantUsers ?? [];
  if (allowed.length > 0 && !allowed.includes(String(user?.email ?? "").toLowerCase())) return null;
  return cfg.assistantUrl;
}

export function openAssistant(url) {
  window.open(url, "_blank", "noopener,noreferrer");
}
